// src/components/Breadcrumb.js
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { addBreadcrumb } from '../store/ApplicationSlice'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded'

const Breadcrumb = () => {
  const breadcrumbs = useSelector(state => state.intakeData.navList)
  const dispatch = useDispatch()
  const location = useLocation()

  const handleBreadcrumbClick = (path, label) => {
    if (location.pathname !== path) {
      dispatch(addBreadcrumb({ path, label }))
    }
  }

  // Ensure the Home path is always included
  const homeBreadcrumb = breadcrumbs.find(item => item.label === 'Home')
  const dynamicBreadcrumbs = breadcrumbs
    .filter(item => item.label !== 'Home')
    .slice(-6)

  const visibleBreadcrumbs = homeBreadcrumb
    ? [homeBreadcrumb, ...dynamicBreadcrumbs]
    : dynamicBreadcrumbs

  return (
    <nav className='breadcrumb'>
      {visibleBreadcrumbs.map((item, index) => {
        const isLast = index === visibleBreadcrumbs.length - 1
        return (
          <span key={`${item.path}-${index}`}>
            <Link
              to={item.path}
              className={`${
                isLast
                  ? 'text-orange-600 font-semibold'
                  : 'text-orange-400 hover:underline'
              }`}
              onClick={() => handleBreadcrumbClick(item.path, item.label)}
            >
              {item.label}
            </Link>
            {index < visibleBreadcrumbs.length - 1 && (
              <span>
                {' '}
                <KeyboardArrowRightRoundedIcon sx={{ color: 'gray' }} />{' '}
              </span>
            )}
          </span>
        )
      })}
    </nav>
  )
}

export default Breadcrumb
